import { useState } from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import Modal from "react-modal";
import emailRejection from "../assets/img/icon/emailRejection.svg";

const cx = classNames.bind(styles);

export default function Footer() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  return (
    <>
      <div className={cx("footerWrap")}>
        <div className={cx("footer")}>
          <div className={cx("footerFront")}>
            <div className={cx("footerLogo")}>회사 로고</div>
            <div className={cx("btn")}>
              <div className={cx("btnRow")}>
                <Link to="/profile">[ 회사개요 ]</Link>
                <div className={cx("contour")}></div>
                <Link to="/profile/map">[ 오시는길 ]</Link>
              </div>
              <div className={cx("emailDenial")} onClick={openModal}>
                [ 이메일 무단수집거부 ]
              </div>
            </div>
            <p className={cx("copyright")}>
              Copyright © 으뜸손해사정.
              <br />
              All rights reserved.
            </p>
          </div>
          <div className={cx("footerMiddle")}>
            <div className={cx("addressWrap")}>
              <div className={cx("address", "seoul")}>
                <div className={cx("location")}>
                  <div className={cx("locationIcon")}></div>
                  <span>서울본사</span>
                </div>
                <p className={cx("addressText")}>
                  서울시 강서구 공항대로 237
                  <br />
                  에이스타워마곡 1306호
                </p>
              </div>
              <div className={cx("address", "gyeonggi")}>
                <div className={cx("location")}>
                  <div className={cx("locationIcon")}></div>
                  <span>경기지점</span>
                </div>
                <p className={cx("addressText")}>
                  경기도 화성시 동탄대로 636-3
                  <br />
                  메가비즈타워 C동 302호
                </p>
              </div>
            </div>
            <div className={cx("fss")}>
              <p>금융감독원 손해사정업 등록업체</p>
            </div>
          </div>
          <div className={cx("footerBack")}>
            <div className={cx("ceo")}>
              <p>
                <span>대표</span>
                <span>채주형</span>
              </p>
              <p>(재물손해사정사 / 대법원 특수감정인)</p>
            </div>
            <div className={cx("contact")}>
              <div className={cx("contactRow")}>
                <div>
                  <div className={cx("telIcon", "callIcon")}></div>
                  <span>T.</span>
                  <span>02-2039-8937</span>
                </div>
                <div className={cx("contour")}></div>
                <div>
                  <div className={cx("telIcon", "phoneIcon")}></div>
                  <span>M.</span>
                  <span>010-9160-8937</span>
                </div>
              </div>
              <div className={cx("contactRow")}>
                <div>
                  <div className={cx("telIcon", "faxIcon")}></div>
                  <span>F.</span>
                  <span>02-2039-8938</span>
                </div>
                <div className={cx("contour")}></div>
                <div>
                  <div className={cx("telIcon", "mailIcon")}></div>
                  <span>E.</span>
                  <span>cjh8937@hanmail.net</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className={cx("modalContent")}
        overlayClassName={cx("modalOverlay")}
      >
        <div className={cx("modalHeader")}>
          <div className={cx("modalHeaderTitle")}>이메일 무단수집거부</div>
          <button onClick={closeModal} className={cx("closeBtn")}>
            &times;
          </button>
        </div>

        <div className={cx("modalBody")}>
          <div className={cx("iconWrap")}>
            <img src={emailRejection} alt="emailRejection" />
          </div>
          <p className={cx("desc")}>
            본 웹사이트는 게시된 이메일 주소가 전자우편 수집 프로그램이나 그
            밖의 기술적 장치를 이용하여 무단 수집되는 것을 거부합니다.
            <br />
            <br />
            이를 위반 시 『정보통신망 이용 촉진 및 정보보호 등에 관한 법률』등에
            의해 처벌받을 수 있습니다.
          </p>
        </div>
        <p className={cx("lawWarning")}>
          ※ 위반 시 정보통신망법에 의해 형사 처벌될 수 있습니다.
        </p>
      </Modal>
    </>
  );
}
